import { useEffect, useState } from "react";

export default function ActionDialog({
  open,
  title,
  children,
  onPositive = null,
  onNegative = null,
  onNeutral = null,
  onClose = null,
  positiveText = "OK",
  negativeText = "Cancel",
  neutralText = "Later",
}) {
  const [show, setShow] = useState(open);

  useEffect(() => {
    if (open) setShow(true);
    else setTimeout(() => setShow(false), 200);
  }, [open]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black/40 transition-opacity duration-200
          ${open ? "opacity-100" : "opacity-0"}
        `}
        onClick={onClose}
      />

      {/* Centered Dialog */}
      <div
        className={`
          bg-backdrop text-white w-[90%] md:w-[26rem] rounded-2xl shadow-xl p-3
          transform transition-all duration-200 sm:translate-x-0 md:translate-x-36
          ${open ? "scale-100 opacity-100" : "scale-95 opacity-0"}
        `}
      >
        {/* Header */}
        {title && (
          <div className="flex justify-center items-center mb-4">
            <span className="text-xl font-semibold">{title}</span>
          </div>
        )}

        {/* Custom content */}
        <div className="mb-6">{children}</div>

        {/* Actions */}
        <div className="flex justify-end gap-3">
          {onNegative && (
            <button onClick={onNegative} className="font-medium m-3">
              {negativeText}
            </button>
          )}

          {onNeutral && (
            <button onClick={onNeutral} className="font-medium m-3">
              {neutralText}
            </button>
          )}

          {onPositive && (
            <button onClick={onPositive} className="font-medium m-3">
              {positiveText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
